<template>
  <div class="longterm">
    <BaseTitle titleText="長照單管理" />

    <section class="longterm__banner">
      <b-row class="longterm__wrapper">
        <!-- 過濾設定面板 -->
        <b-col cols="9" class="longterm__search px-0">
          <section class="bg-white">
            <!-- 預約、補單、、下載 -->
            <div class="mb-4">
              <b-button
                class="longterm__button mr-1"
                variant="success"
                @click="$router.push({ name: 'LongTermReservation' })"
                >+ 預約長照單</b-button
              >
              <b-button
                class="longterm__button mr-1"
                variant="success"
                @click="$router.push({ name: 'LongTermMakeUp' })"
                >補長照單</b-button
              >
              <b-button
                class="longterm__button mr-1 text-white"
                variant="warning"
                @click="$root.$emit('bv::show::modal', 'download-modal')"
                >下載資料</b-button
              >
            </div>
            <!-- 狀態過濾按鈕群組 -->
            <div class="mb-4">
              <b-button-group class="longterm__button-group">
                <b-button
                  v-for="item in ordersStatusOptions"
                  :key="item.value"
                  class="longterm__button"
                  :class="{
                    'longterm__button-active':
                      ordersPagenation.orderStatus === item.value
                  }"
                  @click="handleOrderStatus(item.value)"
                  variant="outline-secondary"
                >
                  {{ item.text }}
                </b-button>
              </b-button-group>
            </div>
            <!-- 進階搜尋 -->
            <div>
              <h2 class="longterm__subtitle mb-3">進階搜尋</h2>
              <div>
                <b-form class="pl-5">
                  <b-row class="longterm__date-search mb-2">
                    <label>預定時間</label>
                    <b-form-datepicker
                      id="longterm__start-date"
                      class="mr-2"
                      :reset-button="true"
                      :value="ordersPagenation.startDate"
                      @input="handleStartDate"
                      placeholder="選擇開始日期"
                    ></b-form-datepicker>
                    <b-form-datepicker
                      id="longterm__end-date"
                      class="mr-2"
                      :reset-button="true"
                      :value="ordersPagenation.endDate"
                      @input="handleEndDate"
                      placeholder="選擇結束日期"
                    ></b-form-datepicker>
                    <b-button-group
                      v-if="dateButtonGroupShow"
                      class="longterm__button-group"
                    >
                      <b-button
                        v-for="item in ordersDateOptions"
                        :key="item.value"
                        :value="ordersDate"
                        @click="handleOrdersDate(item.value)"
                        class="longterm__button"
                        :class="{
                          'longterm__button-active': ordersDate === item.value
                        }"
                        variant="outline-secondary"
                        >{{ item.text }}</b-button
                      >
                    </b-button-group>
                  </b-row>

                  <div class="mb-2">
                    <label>乘客姓名</label>
                    <b-form-input
                      class="longterm__input-basic"
                      :value="ordersPagenation.userName"
                      @input="handleUserName"
                      :debounce="500"
                    ></b-form-input>
                  </div>

                  <div>
                    <label>司機姓名</label>
                    <b-form-input
                      class="longterm__input-basic mr-2"
                      :value="ordersPagenation.driverName"
                      @input="handleDriverName"
                    ></b-form-input>
                    <b-button
                      class="longterm__driver-button longterm__driver-button__submit mr-2"
                      pill
                      variant="outline-danger"
                      @click.prevent="searchOrders"
                      >搜尋</b-button
                    >
                    <b-button
                      class="longterm__driver-button longterm__driver-button__reset mr-2"
                      pill
                      variant="info"
                      @click.prevent="resetSearchData"
                      >清除搜尋條件</b-button
                    >
                  </div>
                </b-form>
              </div>
            </div>
          </section>
        </b-col>
        <!-- 載客與派單卡片 -->
        <b-col class="longterm__status">
          <b-card
            class="longterm__status-passenger position-relative mb-3"
            header="今日載客狀況"
            header-text-variant="light"
          >
            <p class="longterm__status-bill-amount">
              <span>{{ ordersTotalStatus.today.total }}</span
              >張訂單
            </p>
            <div class="longterm__status-progress">
              <b-progress
                :max="100"
                :value="ordersTotalStatus.today.achievementRate"
                height="10px"
              ></b-progress>
              <span>{{ ordersTotalStatus.today.achievementRate }}%</span>
            </div>
            <div class="mb-4">
              <span class="mr-4"
                >{{ ordersTotalStatus.today.waitForDriver }} 張待載客</span
              >
              <span class="mr-4"
                >{{ ordersTotalStatus.today.loadFactor }} 張已載客</span
              >
              <span>{{ ordersTotalStatus.today.waitForSubmit }} 張找司機</span>
            </div>
            <b-button
              class="longterm__status-button"
              @click="refreshTotlaStatus"
              ><RefrechIcon
            /></b-button>
          </b-card>
          <b-card
            class="longterm__status-card position-relative"
            header="明日派車狀況"
            header-text-variant="light"
          >
            <p class="longterm__status-bill-amount">
              <span>{{ ordersTotalStatus.tomorrow.total }}</span
              >張訂單
            </p>
            <div class="longterm__status-progress">
              <b-progress
                :max="100"
                :value="ordersTotalStatus.tomorrow.achievementRate"
                height="10px"
              ></b-progress>
              <span>{{ ordersTotalStatus.tomorrow.achievementRate }}%</span>
            </div>
            <div class="mb-4">
              <span class="mr-4"
                >{{ ordersTotalStatus.tomorrow.waitForDriver }} 張待載客</span
              >
              <span
                >{{ ordersTotalStatus.tomorrow.waitForSubmit }} 張找司機</span
              >
            </div>
            <b-button
              class="longterm__status-button"
              @click="refreshTotlaStatus"
              ><RefrechIcon
            /></b-button>
          </b-card>
        </b-col>
      </b-row>

      <!-- 搜尋標籤 -->
      <div class="longterm__search-tags">
        <p>搜尋條件：</p>
        <template v-for="(item, index) in searchTags">
          <div class="longterm__search-tag" v-if="item.value" :key="index">
            {{ item.fieldText }}: {{ item.value }}
            <CancelIcon
              v-if="!(item.value === '全部')"
              @click="removeSearchTag(item.field)"
            />
          </div>
        </template>
      </div>
    </section>

    <section class="longterm__form longterm__wrapper pt-3">
      <b-form-select
        :value="ordersPagenation.perPage"
        :options="perPageOptions"
        @input="handlePerPage"
        class="longterm__form-perpage"
      >
      </b-form-select>

      <!-- 待驗單列表 -->
      <section v-if="ordersPagenation.orderStatus === 3">
        <div
          v-for="(item, index) in orders"
          class="longterm__card"
          :key="index"
        >
          <div
            class="longterm__card-header d-flex justify-content-between border-bottom"
          >
            <div class="longterm__card-driver">
              <span>{{ item.driverName }}</span>
              <span>{{ item.licenseNumber }}</span>
            </div>
            <div class="longterm__card-id">
              <span>{{ deliveryMethodFormMap(item.deliveryMethod) }}</span>
              <span>{{ item.orderId }}</span>
            </div>
          </div>
          <div class="longterm__card-body">
            <div class="longterm__card-col-1">
              <p class="longterm__card-field">乘客：{{ item.userName }}</p>
              <p class="longterm__card-field">人數：{{ item.seat }}</p>
              <p class="longterm__card-field">
                上車地點：{{ item.onLocation }}
              </p>
              <p class="longterm__card-field">
                下車地點：{{ item.offLocation }}
              </p>
            </div>
            <div class="longterm__card-col-2">
              <p class="longterm__card-field">
                補助方式：{{ item.subsidy.method }}
              </p>
              <p class="longterm__card-field">
                自付比例：{{ item.selfPayRatio }}
              </p>
              <p class="longterm__card-field">
                上車時間：{{ toLocalTime(item.getOnDate) }}
              </p>
              <p class="longterm__card-field">
                下車時間：{{ toLocalTime(item.getOffDate) }}
              </p>
            </div>
            <div class="longterm__card-col-3">
              <p class="longterm__card-field">乘客備註：</p>
              <p class="longterm__card-text">{{ item.serviceNote }}</p>
              <p class="longterm__card-field">司機備註：</p>
              <p class="longterm__card-text">{{ item.driverNote }}</p>
            </div>
            <div class="longterm__card-col-4">
              <p class="longterm__card-field">里程數：{{ item.milage }} 公里</p>
              <p class="longterm__card-field">
                跳錶：{{ item.metreFare.replace('跳 NT ', '') }} 元
              </p>
              <p class="longterm__card-field">
                補助：{{ item.fare.subsidyFare.replace('補 NT ', '') }} 元
              </p>
              <p class="longterm__card-field">
                實收：{{ item.fare.actualFare.replace('實 NT ', '') }} 元
              </p>
            </div>
            <div class="longterm__card-col-5">
              <p class="longterm__card-field">
                驗證：{{ verificationMethodMap(item.verificationMethod) }}
              </p>
              <img
                v-if="item.verificationPhoto"
                :src="item.verificationPhoto"
                alt="乘客簽名"
                class="longterm__card-image"
              />
            </div>
          </div>
          <div class="longterm__card-button-group">
            <b-button
              class="longterm__card-button__check"
              @click="ckechOrder(item.orderId)"
              pill
              >檢視</b-button
            >
            <b-button
              class="longterm__card-button__edit"
              @click="editOrder(item.orderId)"
              pill
              >編輯</b-button
            >
            <b-button
              class="longterm__card-button__confirm"
              pill
              @click="updateOneStatus(item.orderId)"
              >確認</b-button
            >
          </div>
        </div>
      </section>

      <!-- 找司機列表 -->
      <b-table
        v-if="ordersPagenation.orderStatus === 0"
        id="longTermOrdersTable"
        head-variant="light"
        :hover="true"
        :items="orders"
        :fields="findDriverFields"
        responsive="xl"
        class="longterm__table"
      >
        <template #cell(orderStatus)="{ item }">
          <span class="longterm__table-orderStatus positive">{{
            item.orderStatus
          }}</span>
        </template>
        <template #cell(userPhone)="{ item }">
          <div class="longterm__table-user">
            {{ item.user.name }} / {{ item.user.number }}
          </div>
        </template>
        <template #cell(deliveryMethod)="{ item }">
          <BaseSelect
            :value="item.deliveryMethod"
            :text="deliveryMethodFormMap(item.deliveryMethod)"
            :options="deliveryMethodOptions"
            @select="orderDataHandler($event, 'deliveryMethod')"
          />
        </template>
        <template #cell(setDriver)="{ item, index }">
          <InputGroupDriver
            :idOfDriver="`driverId-${item.orderId}`"
            :idOfLicenseNumber="`licenseNumber-${item.orderId}`"
            :driverSearchResult="orderDriverIDSearchResult"
            :licenseNumberSearchResult="orderLicenseNumberSearchResult"
            :driver="
              orderDrivers[index].driverName
                ? orderDrivers[index].driverName
                : ''
            "
            :licenseNumber="
              orderDrivers[index].licenseNumber
                ? orderDrivers[index].licenseNumber
                : ''
            "
            :licenseNumberShow="tableLicenseNumberShow"
            @searchDriverId="inputTableDriver($event, index)"
            @selectDriverId="handleOrderDriver($event, index)"
            @searchLicenseNumber="inputTableLicenseNumber($event, index)"
            @selectLicenseNumber="handleOrderLicenseNumber($event, index)"
            class="longterm__table-driver"
          />
        </template>
        <template #cell(action)="{ item, index }">
          <div class="longterm__table-button">
            <b-button
              class="longterm__table-button__check"
              pill
              size="sm"
              @click="ckechOrder(item.orderId)"
              >檢視</b-button
            >
            <b-button
              class="longterm__table-button__submit"
              pill
              size="sm"
              @click="submitOrderDriver(item.orderId, index)"
              >送出</b-button
            >
          </div>
        </template>
      </b-table>

      <!-- 其它狀態列表 -->
      <b-table
        v-if="
          !(
            ordersPagenation.orderStatus === 3 ||
            ordersPagenation.orderStatus === 0
          )
        "
        id="longTermOrdersTable"
        head-variant="light"
        :hover="true"
        :items="orders"
        :fields="fields"
        responsive="xl"
        class="longterm__table"
      >
        <template #cell(orderStatus)="{ item }">
          <span
            class="longterm__table-orderStatus"
            :class="[
              {
                positive:
                  item.orderStatus === '找司機' ||
                  item.orderStatus === '待載客' ||
                  item.orderStatus === '載客中'
              },
              { negative: item.orderStatus === '取消' },
              { exception: item.orderStatus === '待驗單' }
            ]"
            >{{ item.orderStatus }}</span
          >
        </template>
        <template #cell(address)="{ item }">
          <div class="longterm__table-address">
            {{ item.address.onLocation }}
          </div>
          <div class="longterm__table-address">
            {{ item.address.offLocation }}
          </div>
        </template>
        <template #cell(user)="{ item }">
          <div class="longterm__table-user">
            {{ item.user.name }}
          </div>
          <div class="longterm__table-user">
            {{ item.user.number }}
          </div>
        </template>
        <template #cell(delivery)="{ item }">
          <div
            class="longterm__table-delivery"
            :class="[
              { normal: !item.delivery.methodValue },
              { positive: item.delivery.methodValue }
            ]"
          >
            {{ item.delivery.method }} {{ item.delivery.licenseNumber }}
          </div>
        </template>
        <template #cell(subsidy)="{ item }">
          <div
            class="longterm__table-subsidy"
            :class="[
              { normal: item.subsidy.methodValue === 1 },
              { positive: !item.subsidy.methodValue }
            ]"
          >
            {{ item.subsidy.method }} {{ item.subsidy.licenseNumber }}
          </div>
        </template>
        <template #cell(payOwnselfProportion)="{ item }">
          <div class="longterm__table-payOwnselfProportion">
            {{ item.payOwnselfProportion }}
          </div>
        </template>
        <template #cell(fare)="{ item }">
          <div class="longterm__table-fare">
            {{ item.fare.subsidyFare }}
          </div>
          <div class="longterm__table-fare">
            {{ item.fare.actualFare }}
          </div>
        </template>
        <template #cell(action)="{ item }">
          <div class="longterm__table-button">
            <b-button
              class="longterm__table-button__check"
              pill
              size="sm"
              @click="ckechOrder(item.orderId)"
              >檢視</b-button
            >
          </div>
        </template>
      </b-table>

      <!-- 無資料顯示 -->
      <div v-if="!orders.length" class="text-center mb-3">暫無資料</div>

      <!-- pagenation -->
      <div class="text-right pr-2">
        <b-pagination
          :value="ordersPagenation.currentPage"
          :total-rows="ordersPagenation.totalEntries"
          :per-page="ordersPagenation.perPage"
          @input="handleCurrentPage"
          aria-controls="longTermOrdersTable"
          class="mb-5"
        ></b-pagination>
      </div>
    </section>

    <BaseModal
      id="download-modal"
      title="下載專區"
      size="lg"
      okTitle="下載"
      @onOk="downloadReport"
      @onClose="closeDownloadModal"
    >
      <b-tabs content-class="mt-4 px-5 pb-5" slot="modal-content">
        <b-tab title="車輛出勤日報表" active @click="currentTab = 'daily'">
          <div class="download-modal-date">
            <label>日期</label>
            <b-form-datepicker
              @input="handleDailyReportParams($event, 'date')"
              placeholder="選擇日期"
            ></b-form-datepicker>
          </div>
          <InputGroupDriver
            idOfDriver="dailyDriver"
            idOfLicenseNumber="dailyLicenseNumber"
            :driver="dailyReportParams.driverText"
            :licenseNumber="dailyReportParams.licenseNumber"
            :driverSearchResult="orderDriverIDSearchResult"
            :licenseNumberSearchResult="orderLicenseNumberSearchResult"
            @searchDriverId="inputDailySearchDriver"
            @selectDriverId="handleDailyReportParams($event, 'driverName')"
            @searchLicenseNumber="inputDailySearchLicenseNumber"
            @selectLicenseNumber="
              handleDailyReportParams($event, 'licenseNumber')
            "
            class="download-modal-group-input"
          />
          <p class="download-modal-paragraph">
            總共{{ dailyRecordSearchResult.length }}筆，一次限制100筆下載
          </p>
          <div class="download-modal-select">
            <b-form-select
              :value="downloadPerpageOptions[0]"
              @input="selectDownloadPage"
              :options="downloadPerpageOptions"
            ></b-form-select>
          </div>
        </b-tab>

        <b-tab title="月報表" @click="currentTab = 'monthly'">
          <div class="download-modal-date">
            <label>月份</label>
            <VueMonthlyPicker
              placeHolder="選擇月份"
              :value="monthlyReportParams.date"
              selectedBackgroundColor="#495057"
              :clearOption="false"
              @selected="handleMonthlyReportParams($event, 'date')"
            />
          </div>
          <InputGroupDriver
            idOfDriver="monthlyDriver"
            idOfLicenseNumber="monthlyLicenseNumber"
            :driver="monthlyReportParams.driverText"
            :licenseNumber="monthlyReportParams.license"
            :driverSearchResult="orderDriverIDSearchResult"
            :licenseNumberSearchResult="orderLicenseNumberSearchResult"
            @searchDriverId="inputMonthlySearchDriver"
            @selectDriverId="handleMonthlyReportParams($event, 'driverId')"
            @searchLicenseNumber="inputMonthlySearchLicenseNumber"
            @selectLicenseNumber="handleMonthlyReportParams($event, 'license')"
          />
        </b-tab>

        <b-tab title="衛生局批次表" @click="currentTab = 'goverment'">
          <div class="d-flex">
            <b-form-datepicker
              id="longterm__health-start-date"
              class="mr-3"
              :value="govermentReportParams.startDate"
              @input="handleGovermentReportParams($event, 'startDate')"
              placeholder="選擇開始日期"
            ></b-form-datepicker>
            <b-form-datepicker
              id="longterm__health-end-date"
              :value="govermentReportParams.endDate"
              @input="handleGovermentReportParams($event, 'endDate')"
              placeholder="選擇結束日期"
            ></b-form-datepicker>
          </div>
          <InputGroupDriver
            idOfDriver="govermentDriver"
            idOfLicenseNumber="govermentLicenseNumber"
            :licenseNumber="govermentReportParams.license"
            :driverSearchResult="orderDriverIDSearchResult"
            :licenseNumberSearchResult="orderLicenseNumberSearchResult"
            :driverShow="false"
            @searchLicenseNumber="inputGovermentSearchLicenseNumber"
            @selectLicenseNumber="
              handleGovermentReportParams($event, 'license')
            "
            class="mt-5"
          />
        </b-tab>
        <b-tab title="長照單下載" @click="currentTab = 'orders'">
          <div class="d-flex">
            <b-form-datepicker
              id="longterm__health-start-date"
              class="mr-3"
              :value="ordersDataParams.startDate"
              @input="handleOrdersDataParams($event, 'startDate')"
              placeholder="選擇開始日期"
            ></b-form-datepicker>
            <b-form-datepicker
              id="longterm__health-end-date"
              :value="ordersDataParams.endDate"
              @input="handleOrdersDataParams($event, 'endDate')"
              placeholder="選擇結束日期"
            ></b-form-datepicker>
          </div>
        </b-tab>
      </b-tabs>
    </BaseModal>
  </div>
</template>

<script>
import BaseTitle from '@/components/base/BaseTitle';
import BaseModal from '@/components/base/BaseModal';
import BaseSelect from '@/components/base/BaseSelect';
import InputGroupDriver from '@/components/commen/InputGroupDriver';
import VueMonthlyPicker from 'vue-monthly-picker';
import RefrechIcon from '@/assets/images/refresh.svg';
import CancelIcon from '@/assets/images/close.svg';

import { mapGetters, mapActions } from 'vuex';
import {
  yesterday,
  tomorrow,
  today,
  startOfMouth,
  endOfMouth,
  plusOneDay,
  toLocal
} from '@/utils/moment';
import xmlParse from '@/utils/xmlParse';
import {
  deliveryMethodFormMap,
  verificationMethodMap,
  orderStatusMap
} from '@/utils/optionMaps';
import { errorMessageParse } from '@/utils/errorMessage';

export default {
  name: 'LongTerm',
  components: {
    BaseTitle,
    BaseModal,
    BaseSelect,
    InputGroupDriver,
    VueMonthlyPicker,
    RefrechIcon,
    CancelIcon
  },
  data() {
    return {
      fields: [
        {
          key: 'orderStatus',
          label: '狀態',
          class: 'th-xs-width'
        },
        {
          key: 'estimateDate',
          label: '日期'
        },
        {
          key: 'estimateTime',
          label: '時間',
          class: 'td-style-estimateTime'
        },
        {
          key: 'address',
          label: '地址',
          class: 'th-lg-width'
        },
        {
          key: 'user',
          label: '乘客'
        },
        {
          key: 'delivery',
          label: '派單方式',
          class: 'th-sm-width'
        },
        {
          key: 'driverName',
          label: '司機',
          class: 'th-xs-width'
        },
        {
          key: 'subsidy',
          label: '補助方式',
          class: 'th-sm-width'
        },
        {
          key: 'payOwnselfProportion',
          label: '自付比例',
          class: 'th-xs-width'
        },
        {
          key: 'metreFare',
          label: '跳表金額',
          class: 'th-xs-width'
        },
        {
          key: 'fare',
          label: '補助/實收',
          class: 'th-sm-width'
        },
        {
          key: 'action',
          label: '動作',
          class: 'th-xs-width'
        }
      ],
      findDriverFields: [
        {
          key: 'orderStatus',
          label: '狀態',
          class: 'th-xs-width'
        },
        {
          key: 'estimateDate',
          label: '日期'
        },
        {
          key: 'estimateTime',
          label: '時間',
          class: 'td-style-estimateTime'
        },
        {
          key: 'userPhone',
          label: '乘客/電話',
          class: 'th-lg-width'
        },
        {
          key: 'onLocation',
          label: '上車地址',
          class: 'th-lg-width'
        },
        {
          key: 'offLocation',
          label: '下車地址',
          class: 'th-lg-width'
        },
        {
          key: 'deliveryMethod',
          label: '派單方式',
          class: 'th-md-width'
        },
        {
          key: 'setDriver',
          label: '指定司機和車牌',
          class: 'th-hg-width'
        },
        {
          key: 'action',
          label: '動作',
          class: 'th-sm-width'
        }
      ],
      ordersStatusOptions: [
        {
          value: 0,
          text: '找司機'
        },
        {
          value: 1,
          text: '待載客'
        },
        {
          value: 2,
          text: '載客中'
        },
        {
          value: 3,
          text: '待驗單'
        },
        {
          value: 4,
          text: '完成'
        },
        {
          value: 5,
          text: '取消'
        },
        {
          value: 6,
          text: '全部'
        }
      ],
      ordersDateOptions: [
        {
          value: 0,
          text: '全部'
        },
        {
          value: 1,
          text: '今日'
        },
        {
          value: 2,
          text: '明日'
        },
        {
          value: 3,
          text: '昨日'
        },
        {
          value: 4,
          text: '本月'
        }
      ],
      ordersDate: 0,
      perPageOptions: [25, 50, 100],
      currentTab: 'daily',
      dailyReportParams: {
        startDate: null,
        endDate: null,
        currentPage: 1,
        driverName: '',
        driverText: '',
        driverId: '',
        licenseNumber: ''
      },
      monthlyReportParams: {
        date: null,
        driverId: '',
        driverText: '',
        license: ''
      },
      govermentReportParams: {
        startDate: null,
        endDate: null,
        license: null
      },
      ordersDataParams: {
        startDate: null,
        endDate: null
      },
      selectedMonthlyDriver: '',
      selectedDailyDriver: '',
      orderDrivers: [],
      dateButtonGroupShow: true,
      searchTag: [
        {
          field: '司機',
          value: 'Jinwen'
        },
        {
          field: '乘客',
          value: 'Gengbai'
        }
      ],
      searchKeyWord: {
        userName: null,
        driverName: null
      },
      tableLicenseNumberShow: false
    };
  },
  methods: {
    ...mapActions({
      fetchOrders: 'longTerm/fetchOrders',
      fetchOrderDriverSearch: 'longTerm/fetchOrderDriverSearch',
      fetchDailyRecordSearch: 'longTerm/fetchDailyRecordSearch',
      downloadDailyReport: 'longTerm/downloadDailyReport',
      downloadMonthlyReport: 'longTerm/downloadMonthlyReport',
      downloadGovermentReport: 'longTerm/downloadGovermentReport',
      fetchOrdersTotalStatus: 'longTerm/fetchOrdersTotalStatus',
      downloadOrdersData: 'longTerm/downloadOrdersData',
      updateOrderStatus: 'longTerm/updateOrderStatus',
      updateOrderDriver: 'longTerm/updateOrderDriver'
    }),
    handleCurrentPage(currentPage) {
      this.$store.commit('longTerm/ordersPagenation', {
        ...this.ordersPagenation,
        currentPage
      });
      this.fetchOrders(this.ordersPagenation);
    },
    handlePerPage(perPage) {
      this.$store.commit('longTerm/ordersPagenation', {
        ...this.ordersPagenation,
        perPage
      });
      this.fetchOrders(this.ordersPagenation);
    },
    async handleOrderStatus(orderStatus) {
      this.$store.commit('longTerm/ordersPagenation', {
        ...this.ordersPagenation,
        orderStatus
      });
      await this.fetchOrders(this.ordersPagenation);

      if (orderStatus === 0) {
        this.orderDrivers = this.orders.map(order => ({
          orderId: order.orderId,
          driverId: order.driverId,
          licenseNumber: order.licenseNumber,
          driverName: ''
        }));
      }
    },
    handleOrdersDate(value) {
      this.ordersDate = value;
      switch (value) {
        case 1:
          this.$store.commit('longTerm/ordersPagenation', {
            ...this.ordersPagenation,
            startDate: today(),
            endDate: plusOneDay(today())
          });
          break;
        case 2:
          this.$store.commit('longTerm/ordersPagenation', {
            ...this.ordersPagenation,
            startDate: tomorrow(),
            endDate: plusOneDay(tomorrow())
          });
          break;
        case 3:
          this.$store.commit('longTerm/ordersPagenation', {
            ...this.ordersPagenation,
            startDate: yesterday(),
            endDate: plusOneDay(yesterday())
          });
          break;
        case 4:
          this.$store.commit('longTerm/ordersPagenation', {
            ...this.ordersPagenation,
            startDate: startOfMouth(),
            endDate: endOfMouth()
          });
          break;
        default:
          this.$store.commit('longTerm/ordersPagenation', {
            ...this.ordersPagenation,
            startDate: null,
            endDate: null
          });
          break;
      }
      try {
        this.fetchOrders(this.ordersPagenation);
      } catch (err) {
        console.warn(err);
      }
    },
    handleStartDate(startDate) {
      this.$store.commit('longTerm/ordersPagenation', {
        ...this.ordersPagenation,
        startDate
      });
      if (this.ordersPagenation.startDate && this.ordersPagenation.endDate) {
        this.dateButtonGroupShow = false;
        try {
          this.fetchOrders(this.ordersPagenation);
        } catch (err) {
          console.warn(err);
        }
      } else {
        this.fetchOrders(this.ordersPagenation);
        this.dateButtonGroupShow = true;
        this.ordersDate = 0;
      }
    },
    handleEndDate(endDate) {
      this.$store.commit('longTerm/ordersPagenation', {
        ...this.ordersPagenation,
        endDate
      });
      if (this.ordersPagenation.startDate && this.ordersPagenation.endDate) {
        this.dateButtonGroupShow = false;
        try {
          this.fetchOrders(this.ordersPagenation);
        } catch (err) {
          console.warn(err);
        }
      } else {
        this.fetchOrders(this.ordersPagenation);
        this.dateButtonGroupShow = true;
        this.ordersDate = 0;
      }
    },
    handleUserName(userName) {
      console.log(userName);
      if (!userName) {
        this.searchKeyWord.userName = userName;
        this.$store.commit('longTerm/ordersPagenation', {
          ...this.ordersPagenation,
          userName
        });
        this.fetchOrders(this.ordersPagenation);
        return;
      }
      this.searchKeyWord.userName = userName;
    },
    handleDriverName(driverName) {
      if (!driverName) {
        this.searchKeyWord.driverName = driverName;
        this.$store.commit('longTerm/ordersPagenation', {
          ...this.ordersPagenation,
          driverName
        });
        this.fetchOrders(this.ordersPagenation);
        return;
      }
      this.searchKeyWord.driverName = driverName;
    },
    searchOrders() {
      this.$store.commit('longTerm/ordersPagenation', {
        ...this.ordersPagenation,
        userName: this.searchKeyWord.userName,
        driverName: this.searchKeyWord.driverName
      });
      this.fetchOrders(this.ordersPagenation);
    },
    resetSearchData() {
      this.searchKeyWord = {
        userName: null,
        driverName: null
      };
      this.$store.commit('longTerm/ordersPagenation', {
        perPage: 25,
        currentPage: 1,
        orderStatus: 6,
        startDate: null,
        endDate: null,
        driverName: null,
        userName: null
      });
      this.dateButtonGroupShow = true;
      this.fetchOrders(this.ordersPagenation);
    },
    searchDriverId(value) {
      this.fetchOrderDriverSearch({
        dataType: 'driverId',
        driverData: {
          call_number: value
        }
      });
    },
    searchLicenseNumber(value) {
      this.fetchOrderDriverSearch({
        dataType: 'licenseNumber',
        driverData: {
          license_number: value
        }
      });
    },
    handleDailyReportParams(value, property) {
      console.log('value', value);
      if (property === 'date') {
        this.dailyReportParams.startDate = value;
        this.dailyReportParams.endDate = plusOneDay(value);
      }

      if (property === 'driverName') {
        this.dailyReportParams.driverText = `${value.callNumber}-${value.name}`;
        this.dailyReportParams.driverName = value.name;
        this.dailyReportParams.driverId = value.id;
        this.dailyReportParams.licenseNumber = value.licenseNumber;
      }

      if (property === 'licenseNumber') {
        this.dailyReportParams.licenseNumber = value.licenseNumber;
      }

      this.fetchDailyRecordSearch({
        start_date: this.dailyReportParams.startDate,
        end_date: this.dailyReportParams.endDate,
        driver_name: this.dailyReportParams.driverName,
        license_number: this.dailyReportParams.licenseNumber,
        current_page: this.dailyReportParams.currentPage
      });
    },
    inputDailySearchDriver(driver) {
      if (!driver) {
        this.dailyReportParams.driverText = null;
        this.dailyReportParams.driverName = null;
        this.dailyReportParams.driverId = null;
        this.fetchDailyRecordSearch({
          start_date: this.dailyReportParams.startDate,
          end_date: this.dailyReportParams.endDate,
          driver_name: this.dailyReportParams.driverName,
          license_number: this.dailyReportParams.licenseNumber,
          current_page: this.dailyReportParams.currentPage
        });
      }
      this.searchDriverId(driver);
    },
    inputDailySearchLicenseNumber(licenseNumber) {
      this.dailyReportParams.licenseNumber = licenseNumber;
      this.searchLicenseNumber(licenseNumber);
      this.fetchDailyRecordSearch({
        start_date: this.dailyReportParams.startDate,
        end_date: this.dailyReportParams.endDate,
        driver_name: this.dailyReportParams.driverName,
        license_number: this.dailyReportParams.licenseNumber,
        current_page: this.dailyReportParams.currentPage
      });
    },
    handleMonthlyReportParams(value, property) {
      if (property === 'date') {
        this.monthlyReportParams.date = value._i;
      }

      if (property === 'driverId') {
        this.monthlyReportParams.driverText = value.value;
        this.monthlyReportParams.driverId = value.id;
        this.monthlyReportParams.license = value.licenseNumber;
      }

      if (property === 'license') {
        this.monthlyReportParams.license = value.licenseNumber;
      }
    },
    inputMonthlySearchDriver(driver) {
      if (!driver) {
        this.monthlyReportParams.driverText = null;
        this.monthlyReportParams.driverId = null;
      }
      this.searchDriverId(driver);
    },
    inputMonthlySearchLicenseNumber(licenseNumber) {
      this.monthlyReportParams.license = licenseNumber;
      this.searchLicenseNumber(licenseNumber);
    },
    handleGovermentReportParams(value, property) {
      if (property === 'license') {
        this.govermentReportParams.license = value.licenseNumber;
        return;
      }
      this.govermentReportParams[property] = value;
    },
    inputGovermentSearchLicenseNumber(licenseNumber) {
      this.govermentReportParams.license = licenseNumber;
      this.searchLicenseNumber(licenseNumber);
    },
    handleOrdersDataParams(value, property) {
      this.ordersDataParams[property] = value;
    },
    async downloadReport(e) {
      // 阻止 BootstrapVue 預設行為（按確認關掉 modal）
      e.preventDefault();
      try {
        if (this.currentTab === 'daily') {
          // 如果沒有資料，就不發 request
          if (!this.dailyReportParams.currentPage) {
            this.$store.commit('errorMessage', '目前無資料可供下載');
            this.$root.$emit('bv::show::modal', 'error-modal');
            return;
          }
          const data = await this.downloadDailyReport(this.dailyReportParams);
          const name = `${this.dailyReportParams.startDate}~${this.dailyReportParams.endDate}車輛出勤日報表.xls`;
          xmlParse(data, name);
        }
        if (this.currentTab === 'monthly') {
          const data = await this.downloadMonthlyReport(
            this.monthlyReportParams
          );
          const name = `${this.monthlyReportParams.date}月報表.xls`;
          xmlParse(data, name);
        }
        if (this.currentTab === 'goverment') {
          const data = await this.downloadGovermentReport(
            this.govermentReportParams
          );
          const name = `${this.govermentReportParams.startDate}~${this.govermentReportParams.endDate}衛生局批次表.xls`;
          xmlParse(data, name);
        }
        if (this.currentTab === 'orders') {
          const data = await this.downloadOrdersData(this.ordersDataParams);
          const name = `${this.ordersDataParams.startDate}~${this.ordersDataParams.endDate}衛生局批次表.xls`;
          xmlParse(data, name);
        }
      } catch (err) {
        console.warn('err', err);
        // 因為 response 是 blob 物件，轉的過程會再產生一層 error，所以要 .error
        this.$store.commit('errorMessage', errorMessageParse(err.error));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    },
    async refreshTotlaStatus() {
      try {
        this.fetchOrdersTotalStatus();
      } catch (err) {
        console.warn('err', err);
        this.$store.commit('errorMessage', errorMessageParse(err.error.error));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    },
    deliveryMethodFormMap(value) {
      return deliveryMethodFormMap(value);
    },
    verificationMethodMap(value) {
      return verificationMethodMap(value);
    },
    ckechOrder(orderId) {
      this.$router.push({
        name: 'LongTermOrder',
        params: { id: orderId, action: 'read' }
      });
    },
    editOrder(orderId) {
      this.$router.push({
        name: 'LongTermOrder',
        params: { id: orderId, action: 'edit' }
      });
    },
    toLocalTime(utcTime) {
      if (!utcTime) return '';
      return toLocal(utcTime);
    },
    async updateOneStatus(orderId) {
      try {
        await this.updateOrderStatus({
          orderId,
          payload: {
            status: 4
          }
        });
        this.$bvToast.toast('驗單成功', {
          toaster: 'b-toaster-top-center',
          variant: 'success',
          solid: true
        });
        this.fetchOrders(this.ordersPagenation);
      } catch (err) {
        console.warn(err);
        this.$store.commit('errorMessage', errorMessageParse(err));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    },
    handleOrderDriver(driver, index) {
      this.tableLicenseNumberShow = true;
      this.orderDrivers[index].driverId = driver.id;
      this.orderDrivers[index].licenseNumber = driver.licenseNumber;
      this.orderDrivers[index].driverName = driver.value;
    },
    handleOrderLicenseNumber(driver, index) {
      this.orderDrivers[index].licenseNumber = driver.licenseNumber;
    },
    inputTableDriver(driver, index) {
      if (!driver) {
        this.orderDrivers[index].driverId = null;
        this.orderDrivers[index].driverName = null;
      }
      this.orderDrivers[index].driverId = driver;
      this.searchDriverId(driver);
    },
    inputTableLicenseNumber(licenseNumber, index) {
      this.orderDrivers[index].licenseNumber = licenseNumber;
      this.searchLicenseNumber(licenseNumber);
    },
    async submitOrderDriver(orderId, index) {
      try {
        await this.updateOrderDriver({
          orderId,
          payload: this.orderDrivers[index]
        });
        this.$bvToast.toast('司機發派成功', {
          toaster: 'b-toaster-top-center',
          variant: 'success',
          solid: true
        });
        this.fetchOrders(this.ordersPagenation);
      } catch (err) {
        console.warn(err);
        this.$store.commit('errorMessage', errorMessageParse(err));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    },
    removeSearchTag(field) {
      if (field === 'date') {
        this.$store.commit('longTerm/ordersPagenation', {
          ...this.ordersPagenation,
          startDate: null,
          endDate: null
        });
        this.dateButtonGroupShow = true;
        this.ordersDate = 0;
      }
      if (field === 'orderStatus') {
        this.$store.commit('longTerm/ordersPagenation', {
          ...this.ordersPagenation,
          orderStatus: 6
        });
      }
      if (field === 'userName') {
        this.$store.commit('longTerm/ordersPagenation', {
          ...this.ordersPagenation,
          userName: null
        });
      }
      if (field === 'driverName') {
        this.$store.commit('longTerm/ordersPagenation', {
          ...this.ordersPagenation,
          driverName: null
        });
      }
      this.fetchOrders(this.ordersPagenation);
    },
    selectDownloadPage(page) {
      this.dailyReportParams.currentPage = page;
    },
    closeDownloadModal(e) {
      // 如果是按確認下載，就不要重設 form
      if (e.trigger === 'ok') return;

      this.dailyReportParams = {
        startDate: null,
        endDate: null,
        currentPage: 1,
        driverName: '',
        driverId: '',
        licenseNumber: ''
      };
      this.selectedDailyDriver = '';
      this.$store.commit('longTerm/downloadPerpageOptions', [0]);
      this.$store.commit('longTerm/dailyRecordSearchResult', []);

      this.monthlyReportParams = {
        date: null,
        driverId: '',
        license: ''
      };
      this.selectedMonthlyDriver = '';

      this.govermentReportParams = {
        startDate: null,
        endDate: null,
        license: null
      };
    }
  },
  computed: {
    ...mapGetters({
      orders: 'longTerm/orders',
      ordersPagenation: 'longTerm/ordersPagenation',
      ordersTotalStatus: 'longTerm/ordersTotalStatus',
      orderDriverIDSearchResult: 'longTerm/orderDriverIDSearchResult',
      orderLicenseNumberSearchResult: 'longTerm/orderLicenseNumberSearchResult',
      dailyRecordSearchResult: 'longTerm/dailyRecordSearchResult',
      deliveryMethodOptions: 'longTerm/deliveryMethodOptions',
      downloadPerpageOptions: 'longTerm/downloadPerpageOptions'
    }),
    searchTags() {
      let array = [];
      array.push({
        fieldText: '狀態',
        field: 'orderStatus',
        value: orderStatusMap(this.ordersPagenation.orderStatus)
          ? orderStatusMap(this.ordersPagenation.orderStatus)
          : '全部'
      });
      array.push({
        fieldText: '預定時間',
        field: 'date',
        value:
          this.ordersPagenation.startDate && this.ordersPagenation.endDate
            ? `${this.ordersPagenation.startDate} 至 ${this.ordersPagenation.endDate}`
            : '全部'
      });
      array.push({
        fieldText: '乘客',
        field: 'userName',
        value: this.ordersPagenation.userName
      });
      array.push({
        fieldText: '司機',
        field: 'driverName',
        value: this.ordersPagenation.driverName
      });
      return array;
    }
  },
  mounted() {
    if (this.ordersPagenation.orderStatus === 0) {
      this.orderDrivers = this.orders.map(order => ({
        orderId: order.orderId,
        driverId: order.driverId,
        licenseNumber: order.licenseNumber,
        driverName: ''
      }));
    }
  }
};
</script>

<style lang="scss" scoped>
.longterm {
  font-size: 14px;

  &__subtitle {
    margin: 10px 0;
    font-size: 18px;
    font-weight: 400;
    color: #73879c;
  }

  label {
    color: #606266;
    margin-right: 10px;
  }

  &__wrapper {
    max-width: 1920px;
    margin: 0 auto;
    .form-control.b-form-datepicker {
      width: 210px;
      flex-grow: 0;
    }
  }

  &__banner {
    background-color: #ecf0f5;
    padding: 20px 15px 20px 40px;
  }

  &__status {
    font-size: 13px;
    &-progress {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .progress {
        flex-grow: 1;
        margin-right: 10px;
      }
      span {
        font-size: 0.9rem;
      }
    }
    &-passenger {
      .card-header {
        background-color: #18a55d;
      }
    }
    &-card {
      .card-header {
        background-color: #00c0ef;
      }
    }
    &-bill-amount {
      span {
        margin-right: 5px;
        font-size: 30px;
      }
    }
    &-button {
      position: absolute;
      top: 0;
      right: 0;
      background-color: inherit;
      border: none;
      padding: 3px 10px;
      svg {
        transform: scale(0.7);
      }
    }
  }

  &__date-search {
    align-items: center;
    margin: 0;
  }

  &__button-group {
    .longterm__button {
      border-color: $border-gentle;
      transition: none;
      &:hover,
      &-active {
        background-color: $positive;
        border-color: $positive;
        color: $white;
      }
    }
  }

  &__form {
    padding: 0 30px;

    &-perpage {
      width: 200px;
      margin-bottom: 20px;
    }
  }

  &__table {
    &-orderStatus {
      width: 100%;
      display: block;
      text-align: center;
      padding: 3px 5px;
      border: 2px solid $text-regular;
      border-radius: 3px;
    }

    &-button {
      font-size: 12px;
      &__check {
        display: block;
        margin-bottom: 3px;
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
      }
      &__submit {
        display: block;
        margin-bottom: 3px;
        color: $normal;
        background: #ecffec;
        border-color: #9ee4a0;
      }
    }

    &-delivery,
    &-subsidy {
      padding: 3px 2px;
      text-align: center;
      border: 2px solid;
      border-radius: 3px;
    }

    .normal {
      color: $normal;
      border-color: $normal;
    }

    .positive {
      color: $positive;
      border-color: $positive;
    }

    .negative {
      color: $negative;
      border-color: $negative;
    }

    .exception {
      color: $exception;
      border-color: $exception;
    }
  }

  &__driver-button {
    &__submit {
      color: #409eff;
      background: #ecf5ff;
      border-color: #b3d8ff;
    }
    &__reset {
      color: #f56c6c;
      background: #fef0f0;
      border-color: #fbc4c4;
    }
  }

  &__card {
    margin-bottom: 30px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 5px;
    color: $text-dark;
    &-header {
      padding: 20px 80px;
      font-size: 14px;
      font-weight: bold;
      span:first-child {
        margin-right: 15px;
      }
    }
    &-body {
      display: flex;
      justify-content: space-between;
      padding: 20px 80px;
    }
    &-field {
      margin-bottom: 10px;
    }
    &-image {
      width: 100%;
    }
    &-button {
      &-group {
        padding: 10px 80px 30px;
        text-align: right;
      }
      &__check {
        margin-right: 20px;
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
      }
      &__edit {
        margin-right: 20px;
        color: #e39b1f;
        background: #fcf6d9;
        border-color: #f5d557;
      }
      &__confirm {
        color: #67c23a;
        background: #f0f9eb;
        border-color: #c2e7b0;
      }
    }
    &-col-3 {
      flex: 0 0 150px;
    }
    &-col-5 {
      flex: 0 0 300px;
    }
  }

  &__search {
    > section {
      padding: 56.5px 20px;
      border-radius: 5px;
    }
    &-tags {
      display: flex;
      background-color: $white;
      padding: 10px 20px;
      margin-top: 15px;
      margin-right: 15px;
      border-radius: 5px;
      p {
        line-height: 30px;
        margin-bottom: 0;
      }
    }
    &-tag {
      width: fit-content;
      padding: 5px 10px 7px;
      margin-right: 5px;
      border-radius: 99999px;
      background-color: $positive;
      color: $white;
      svg {
        width: 10px;
        height: 10px;
        cursor: pointer;
        margin-left: 3px;
        path {
          fill: $white;
        }
      }
    }
  }

  &__input {
    &-basic {
      display: inline-block;
      width: 428px !important;
    }
  }
}

.form-control.b-form-datepicker {
  flex-grow: 1;
}

.form-control {
  width: auto;
}

.b-form-btn-label-control.form-control {
  font-size: 14px;
}

::v-deep.longterm__form-button {
  .longterm__form-button__check,
  .longterm__form-button__edit {
    font-size: 10px;
  }
}

.pagination {
  float: right;
}

.card {
  border: 0;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  &-header {
    border: 0;
    padding: 5px 15px;
  }
}

.download-modal {
  &-date {
    display: flex;
    align-items: center;
    padding: 20px 80px;
    border-bottom: 1px solid $border-light;
    &:hover {
      background-color: #fafafa;
    }
    .datepicker {
      flex-grow: 1;
    }
    label {
      flex: 0 0 80px;
      font-size: 13px;
      margin-bottom: 0;
    }
  }
  &-group-input {
    border-bottom: 1px solid $border-light;
  }
  &-paragraph {
    padding: 20px 80px 10px;
  }
  &-select {
    padding: 0 80px;
  }
}

::v-deep .table td {
  vertical-align: middle;
  color: $text-regular;
}

::v-deep .table .thead-light th {
  background-color: $border-light;
  color: #909399;
}

::v-deep .table thead th {
  border: none;
}

::v-deep .table tr:first-child td {
  border: none;
}

::v-deep .table-hover tbody tr:hover {
  background-color: #fafafa;
}

::v-deep .th-xs-width {
  flex: 0 0 80px;
}

::v-deep .th-sm-width {
  width: 100px;
}

::v-deep .th-md-width {
  width: 150px;
}

::v-deep .th-lg-width {
  min-width: 150px;
  max-width: 200px;
}

::v-deep .th-hg-width {
  min-width: 180px;
  max-width: 220px;
}

::v-deep td.td-style-estimateTime {
  font-size: 25px;
}

::v-deep .tab-content {
  font-size: 13px;
}

.b-form-btn-label-control.form-control {
  align-items: center;
}

::v-deep .vue-monthly-picker {
  flex-grow: 1;
}

::v-deep .month-year-display.input {
  color: $border-regular;
  font-size: 14px;
}

::v-deep .month-year-display.input.placeholder {
  color: #c0c4cc;
}

::v-deep .longterm__table-driver .autocomplete label {
  display: none;
}

::v-deep .longterm__table-driver.inputgroupdriver .autocomplete {
  padding: 0;
}

::v-deep .longterm__table-driver .autocomplete:last-child {
  margin-top: 5px;
}

::v-deep .inputgroupdriver .autocomplete:first-child {
  border-bottom: 0;
}
</style>
